import { getInstance } from '../lib/Auth0'

const defaults = {
  hasCofundingAccess: false,
  registrationComplete: true,
  roles: false
}

export default (options = {}) => {
  return (to, from, next) => {
    const authService = getInstance()
    const opts = { ...defaults, ...options }

    const fn = () => {
      // If the user is authenticated, continue with the route.
      if (authService.isAuthenticated) {
        // Check to see if user has completed registration.
        if (opts.registrationComplete) {
          const { registrationComplete, registrationStep } = authService.user.meta

          if (!registrationComplete) {
            return next({ name: `register.${registrationStep || 'start'}` })
          }
        }

        // Check to see if authenticated user belongs to a certain role.
        if (opts.roles) {
          if (!authService.hasRole(opts.roles)) {
            return next(false)
          }
        }

        // Are we checking that the user has co-funding access?
        if (opts.hasCofundingAccess && authService.user.hasCofundingAccess !== true) {
          return next({ name: 'dashboard' })
        }

        return next()
      }

      // Otherwise, log in
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
    }

    // If loading has already finished, check our auth state using `fn()`
    if (!authService.loading) {
      return fn()
    }

    // Watch for the loading property to change before we check isAuthenticated
    authService.$watch('loading', loading => {
      if (loading === false) {
        return fn()
      }
    })
  }
}
